import React from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import SuccessImage from './svg/SuccessImage';
import FailureImage from './svg/FailureImage';
import {prepareUrl} from "app/utilities/StringHelpers/StringHelpers";

export const CompletedWithSuccess = ({props}) => {
  return (
    <div className='completeContainer'>
      <SuccessImage />
      <div className='heading'>הדו"ח בדרך אליך</div>
      <div className='subHeading'>קיבלנו את בקשתך להפקת הדו"ח ונשלח אותו אליך במהלך השעות הקרובות</div>
      <div className='footerButton submitDiv'>
        <BtnSubmit onclick={() => prepareUrl('', props.context)} text='חזרה למסך הבית' isBusiness={true} />
      </div>
    </div>
  );
};

export const CompletedWithError = ({props}) => {
  return (
    <div className='completeContainer'>
      <FailureImage />
      <div className='heading'>לא הצלחנו לשלוח את הדו"ח</div>
      <div className='subHeading'>משהו השתבש ולא הצלחנו לייצר את הדו"ח, אנא נסה שנית</div>
      <div className='footerButton submitDiv'>
        <BtnSubmit onclick={() => prepareUrl('', props.context)} text='חזרה למסך הבית' isBusiness={true} />
      </div>
    </div>
  );
};
